import React from "react"
import Link from "next/link"
import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string // Make it optional
  label?: string
  className?: string
  variant?: "default" | "primary" | "secondary" | "outline"
  target?: string
  rel?: string
}

const CustomButton: React.FC<ButtonProps> = ({
  href = "#", // Default to "#" if href is not provided
  label = "View More",
  className,
  variant = "default",
  target,
  rel,
  ...props
}) => {
  const button = (
    <button
      className={cn(
        buttonVariants({ variant }),
        "w-fit cursor-pointer font-gilroySemiBold hover:bg-white hover:text-black border border-black px-9 lg:px-16",
        className
      )}
      {...props}
    >
      {label}
    </button>
  )

  return href ? (
    <Link prefetch={false}  href={href} target={target} rel={rel} aria-label="button">
      {button}
    </Link>
  ) : (
    button
  )
}

export default CustomButton
